import { FC } from 'react';
import { H3, P } from '@ahmdigital/ui';
import { map } from 'lodash/fp';

import { OptionBox, OptionButton, OptionContainer, OptionContentRow } from './styles';
import type { ContactProps } from '../types';

export type ContactOptionProps = ContactProps & {
  buttonOnClick?: () => void;
  isButtonDisabled?: boolean;
  isHighlighted?: boolean;
};

const ContactOption: FC<ContactOptionProps> = ({
  buttonOnClick,
  buttonText,
  buttonUrl,
  isButtonDisabled = false,
  subText,
  title,
  isHighlighted = false,
}) => (
  <OptionContainer>
    <OptionBox data-testid="optionBox" isHighlighted={isHighlighted}>
      <OptionContentRow variant="paddingBottomSpacer6">
        <H3 looksLike="h4" variant={['marginBottomSpacer11']}>
          {title}
        </H3>
        {map(
          (text) => (
            <P variant={['small14', 'withoutMargin']} key={text}>
              {text}
            </P>
          ),
          subText,
        )}
      </OptionContentRow>
      <OptionContentRow variant="paddingBottomSpacer11">
        {(buttonUrl || buttonOnClick) && buttonText && (
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call.
          <OptionButton onClick={buttonOnClick} to={buttonUrl} size="auto" disabled={isButtonDisabled}>
            {buttonText}
          </OptionButton>
        )}
      </OptionContentRow>
    </OptionBox>
  </OptionContainer>
);

export default ContactOption;
